export default __webpack_public_path__ + "static/media/backbone-icon.fbaaa91f.svg";